import { CustomLink } from ".."
import { Assets } from "../styles/assets"
import { BtnDarnStyle, Loading } from "./style"

type Props = {
    children: React.ReactNode,
    disabled?: boolean,
    loading?: boolean,
    width?: string,
    height?: string,
    margintop?: string,
    marginbottom?: string
    onClick?: () => void
    goToPage?: string    
}

export const ButtonDark = ({
    children,
    disabled,
    loading,
    width,
    height,
    margintop,
    marginbottom,
    onClick,
    goToPage,    
}: Props) => {

    const Button = () => (
        <BtnDarnStyle
            disabled={loading || disabled}
            width={width || "100%"}
            height={height || "52px"}
            margintop={margintop}
            marginbottom={marginbottom}            
            type={onClick ? "button" : "submit"}
            onClick={onClick}
            >
            {children}
            {loading && <Loading src={Assets.loadingBlack} alt="loading" />}
        </BtnDarnStyle>
    )

    return (
        goToPage ? <CustomLink to={goToPage} width={width}><Button /></CustomLink> : <Button />
    )
}